import React, { Component } from "react";
import { Modal } from "@material-ui/core";
import { GetCustomerDetails } from "../../../../services";

export default class SubEdit extends Component {
  constructor(props) {
    super(props);

    const {
      fullName = "",
      phone = "",
      email = "",
      gender = "active",
      offer = "Not Claimed",
    } = props.state || {};

    this.state = {
      fullName,
      phone,
      email,
      gender,
      offer,
      open: false,
      loading: false,
    };
  }

  handleChange = (e) => {
    const {
      name,
      value,
    } = e.target;

    this.setState({
      [name]: value,
    });
  };

  handleOpen = () => {
    const {
      fullName = "",
      phone = "",
      email = "",
      gender = "active",
      offer = "Not Claimed",
    } = this.props.state || {};

    this.setState({
      fullName,
      phone,
      email,
      gender,
      offer,
      open: true,
    });
  };

  handleClose = () => {
    if (this.state.loading) {
      return;
    }

    this.setState({
      open: false,
    });
  };

  handleSubmit = async () => {
    const {
      id,
    } = this.props.state || {};

    const {
      fullName,
      gender,
      offer,
    } = this.state;

    if (!id) {
      console.error(
        "Customer ID missing"
      );
      return;
    }

    /*
     * IMPORTANT:
     * Phone and email are intentionally
     * NOT included here because they
     * cannot be edited.
     */
    const data = {
      id: String(id),
      fullName: fullName.trim(),
      gender,
      offer,
    };

    try {
      this.setState({
        loading: true,
      });

      const response =
        await GetCustomerDetails.getCustomerUpdate(
          data
        );

      console.log(
        "Customer update response:",
        response
      );

      if (
        response &&
        response.success === true
      ) {
        this.setState(
          {
            open: false,
          },
          () => {
            if (
              typeof this.props.onUpdate ===
              "function"
            ) {
              this.props.onUpdate({
                ...this.props.state,
                ...data,
              });
            }
          }
        );
      } else {
        console.error(
          "Customer update failed:",
          response
        );
      }
    } catch (error) {
      console.error(
        "Customer update error:",
        error
      );
    } finally {
      this.setState({
        loading: false,
      });
    }
  };

  render() {
    const {
      open,
      loading,
      fullName,
      phone,
      email,
      gender,
      offer,
    } = this.state;

    return (
      <div>
        <button
          type="button"
          className="edit-btn"
          onClick={this.handleOpen}
          style={{
            border: "none",
            background: "transparent",
            cursor: "pointer",
            padding: "5px",
          }}
          title="Edit Customer"
        >
          <i className="fas fa-edit" />
        </button>

        <Modal
          open={open}
          onClose={this.handleClose}
          aria-labelledby="edit-customer-title"
        >
          <div
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform:
                "translate(-50%, -50%)",
              width: "90%",
              maxWidth: "600px",
              maxHeight: "90vh",
              overflowY: "auto",
              backgroundColor: "#fff",
              borderRadius: "12px",
              boxShadow:
                "0 10px 40px rgba(0,0,0,0.25)",
              outline: "none",
            }}
          >
            {/* HEADER */}

            <div
              className="modal-header bg-primary text-white"
              style={{
                borderRadius:
                  "12px 12px 0 0",
              }}
            >
              <h5
                id="edit-customer-title"
                className="modal-title"
              >
                Update Customer
              </h5>

              <button
                type="button"
                className="close text-white"
                onClick={
                  this.handleClose
                }
                disabled={loading}
                style={{
                  background:
                    "transparent",
                  border: "none",
                  fontSize: "28px",
                  cursor: loading
                    ? "not-allowed"
                    : "pointer",
                }}
              >
                <span aria-hidden="true">
                  ×
                </span>
              </button>
            </div>

            {/* BODY */}

            <div
              className="modal-body"
              style={{
                padding: "20px",
              }}
            >
              {/* FULL NAME - EDITABLE */}

              <div className="form-group">
                <label className="form-label">
                  Full Name*
                </label>

                <input
                  type="text"
                  className="form-control"
                  name="fullName"
                  value={fullName}
                  onChange={
                    this.handleChange
                  }
                  disabled={loading}
                />
              </div>

              {/* PHONE - NOT EDITABLE */}

              <div className="form-group">
                <label className="form-label">
                  Phone*
                </label>

                <input
                  type="text"
                  className="form-control"
                  name="phone"
                  value={phone}
                  readOnly
                  disabled={loading}
                  style={{
                    backgroundColor:
                      "#f5f5f5",
                    cursor: "not-allowed",
                  }}
                />

                <small
                  className="text-muted"
                >
                  Phone number cannot be
                  changed.
                </small>
              </div>

              {/* EMAIL - NOT EDITABLE */}

              <div className="form-group">
                <label className="form-label">
                  Email*
                </label>

                <input
                  type="email"
                  className="form-control"
                  name="email"
                  value={email}
                  readOnly
                  disabled={loading}
                  style={{
                    backgroundColor:
                      "#f5f5f5",
                    cursor: "not-allowed",
                  }}
                />

                <small
                  className="text-muted"
                >
                  Email address cannot be
                  changed.
                </small>
              </div>

              {/* STATUS - EDITABLE */}

              <div className="form-group">
                <label className="form-label">
                  Status*
                </label>

                <select
                  className="form-control"
                  name="gender"
                  value={gender}
                  onChange={
                    this.handleChange
                  }
                  disabled={loading}
                >
                  <option value="active">
                    Active
                  </option>

                  <option value="inactive">
                    Inactive
                  </option>
                </select>
              </div>

              {/* OFFER - EDITABLE */}

              <div className="form-group">
                <label className="form-label">
                  Offer*
                </label>

                <select
                  className="form-control"
                  name="offer"
                  value={offer}
                  onChange={
                    this.handleChange
                  }
                  disabled={loading}
                >
                  <option value="Not Claimed">
                    Not Claimed
                  </option>

                  <option value="Claimed">
                    Claimed
                  </option>
                </select>
              </div>
            </div>

            {/* FOOTER */}

            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                onClick={
                  this.handleClose
                }
                disabled={loading}
              >
                Close
              </button>

              <button
                type="button"
                className="btn btn-primary"
                onClick={
                  this.handleSubmit
                }
                disabled={loading}
              >
                {loading
                  ? "Saving..."
                  : "Save changes"}
              </button>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/admin/view/customer/edit/index.js